import creditCardType from 'credit-card-type';

creditCardType.addCard({
  niceType: 'Uzcard',
  type: 'uzcard',
  patterns: [8600, 6262, 5614],
  gaps: [4, 8, 12],
  lengths: [16],
  code: null,
});

creditCardType.addCard({
  niceType: 'Humo',
  type: 'humo',
  patterns: [9860],
  gaps: [4, 8, 12],
  lengths: [16],
  code: null,
});

creditCardType.updateCard(creditCardType.types.MAESTRO, {
  gaps: [8],
});

export default creditCardType;
